module.exports = __webpack_public_path__ + "img/etsy.c71610fb.svg";